import { ReactNode } from "react";
import Header from "../components/Header";
import MobileHeader from "../components/Header.mobile";

function HeaderLayout({ children }: { children: ReactNode }) {
  return (
    <main>
      <div className="hidden sm:block">
        <Header />
      </div>
      <div className="sm:hidden block">
        <MobileHeader />
      </div>
      {children}
    </main>
  );
}

export default HeaderLayout;
